import React, {useContext} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import ClearingSystemResultPanel from "./ClearingSystemResultPanel";
import ClearingSystemCreatePanel from "./ClearingSystemCreatePanel";
import {ClearingSystemContext, CLEARING_SYSTEM_CREATE_PAGE} from "./context";

export default function ClearingSystemPanel() {

    const {clearingSystemPanelPageState} = useContext(ClearingSystemContext);

    function mainComponent() {
        if (clearingSystemPanelPageState.currentPage === CLEARING_SYSTEM_CREATE_PAGE) {
            return <ClearingSystemCreatePanel/>;
        }
        return <ClearingSystemResultPanel/>;
    }

    return (<>
        <Container fluid>
            <Row>
                <Col style={{padding: 0}}>
                    {mainComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}

